export const DECISION_DIALOG = {
  VALIDATION: 'dialogValidation',
  REFUSAL: 'dialogRefusal',
} as const;
